"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userContent = userContent;
var _request = _interopRequireDefault(require("@/utils/request"));
function userContent(token, uuid) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const res = (0, _request.default)({
    url: `\contents?userUuid=${uuid}&sort=createdAt`,
    method: 'get',
    headers
  });
  return res;
}